<template>
    <div>
        <el-tree :expand="expand" ref="treeX" :default-expanded-keys="[1]" :default-checked-keys="[1]" :data="bumendata" empty-text="未获取到部门数据" node-key="id" :props="defaultProps" @check-change="handleCheckChange" @node-click="handleNodeClick"></el-tree>
    </div>
</template>

<script>
import { departmentTree } from '@/api/department'

export default {
    name: '',
    props:{
        expand:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bumendata: [],
            defaultProps: {
                children: 'child',
                label: 'name'
            }
        }
    },
    methods: {
        getDepartmentTree() {
            departmentTree({serviceCode: 'SYS-USER'}).then(response => {
                // console.log(response.data)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }else{
                    this.bumendata = response.data
                    this.$emit('nodeData', this.bumendata)
                }
            })
        },
        handleNodeClick(data) {
            console.log("部门树形node",data)
            this.$emit('nodeChange', data.id)
        },
        handleCheckChange(data, checked, indeterminate){
            console.log('部门树形check',checked, indeterminate)
            this.$emit('checkChange', data.id, checked)
        }
    },
    created() {
        this.getDepartmentTree()
        // console.log('重新加载了')
    },
    watch: {
        expand:{
            handler: function () {
                for (var i = 0; i < this.$refs.treeX.store._getAllNodes().length; i++) {
                    this.$refs.treeX.store._getAllNodes()[i].expanded = this.expand
                }
                // console.log('当前状态',this.expand,this.$refs.treeX.store._getAllNodes())
            }
        }
    }
}
</script>

<style scoped>

</style>
